import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconCopyStyle0 = gravityIconIndividualCss;

const GravityIconCopy = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'a5ce54a9c08b4065317145687ba7b7149e42cd5d', color: this.color, size: this.size }, h("svg", { key: 'e4d6070d57b5c890c162850b972609ceeed9b989', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'e40b32fc8112090febe6ab5b1531ee7e015661ad', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-11Zm8.5 10v-9h-7v9h7Z", fill: "currentColor" }), h("path", { key: 'db97e466e661d9d493338e930f617f3686a9f286', d: "M13.5 16a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V8a.5.5 0 0 1-.5.5h-1v9h7v-1a.5.5 0 0 1 .5-.5h.5Z", fill: "currentColor" }))));
    }
};
GravityIconCopy.style = GravityIconCopyStyle0;

export { GravityIconCopy as gravity_icon_copy };

//# sourceMappingURL=gravity-icon-copy.entry.js.map